import { MarketingShell } from "@/components/landing/MarketingShell";
import { Testimonials } from "@/components/landing/Testimonials";
import { SeoHead } from "@/components/useSeo";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="product-testimonials"
      title="Testimonials — DollarDeploy"
      description="See what developers say about deploying with DollarDeploy."
    />
    <section className="container py-20">
      <Testimonials />
    </section>
  </MarketingShell>
);

export default Page;
